import { PageLoader as HaloPageLoader } from '@prenuvo/halo-web';

import { FullPageLayout } from '../layout';

interface PageLoaderProps {
  alt?: string;
  children?: React.ReactNode;
  className?: string;
}

export function PageLoader({ alt, children, className }: PageLoaderProps) {
  return (
    <FullPageLayout className={className}>
      <HaloPageLoader alt={alt} variant="dark" />
      {children}
    </FullPageLayout>
  );
}
